import React from 'react'

const Assessments = () => {
  return (
    <div>
      <h1>Assessments Component</h1>
    </div>
  )
}

export default Assessments
